export default "__VITE_PUBLIC_ASSET__d2b69383__"